import React from 'react'
import classes from './AddTimeModal.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { setOpenAddTime } from '../../../../../../../redux/globalSlice'
import { Box, Modal, Typography } from '@mui/material'
import TextField from '../../../../../../../components/TextField/Textfield'
import { SelectField } from '../../../../../../../components'

const AddTimeModal = ({ setFormValues, formValues, onAddPeriod, typeEnums }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 471,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    outline: 'none',
    borderRadius: '24px',
  }

  const open = useSelector((state) => state.global.openAddTime)
  const dispatch = useDispatch()

  const handleClose = () => {
    setFormValues({ period_name: '', start_date: '', end_time: '', type: '' })
    dispatch(setOpenAddTime(false))
  }

  const handleConfirm = () => {
    if (
      !formValues.period_name?.trim() ||
      !formValues.start_date?.trim() ||
      !formValues.end_time?.trim() ||
      !formValues.type?.trim()
    ) {
      alert('Please fill all fields')
      return
    }

    onAddPeriod({
      period_name: formValues.period_name.trim(),
      start_time: formValues.start_date.trim(),
      end_time: formValues.end_time.trim(),
      type: formValues.type.trim(),
    })

    handleClose()
  }

  // console.log('---formValues?.start_date ',formValues?.start_date );
  

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <div className={classes.container}>
          <div className="header-registration">
            <p className="modalheadtxt">Add New Time</p>
          </div>

          <TextField
            placeholder={'eg, for teacher or for a class'}
            value={formValues?.period_name || ''}
            onChange={(e) => setFormValues({ ...formValues, period_name: e.target.value })}
            label={'Period Name'}
            required={true}
            width={'100%'}
          />

          <SelectField
            placeholder={'Select Period Type'}
            required
            options={(typeEnums || [])?.map((item) => ({
              value: item?.value,
              label: item?.label,
            }))}
            onChange={(selectedOption) => setFormValues({ ...formValues, type: selectedOption })}
            value={formValues?.type || ''}
            label={'Period Type'}
            flex={true}
            width={'auto'}
          />

          <div className={classes.grid}>
            {/* Start Time - native time input */}
            <div className={classes.timeFieldWrapper}>
              <label className={classes.timeLabel}>
                Start Time <span className="req">*</span>
              </label>
              <input
                type="time"
                value={formValues?.start_date || ''}
                onChange={(e) => setFormValues({ ...formValues, start_date: e.target.value })}
                required
                className={classes.timeInput}
                step="3600" // 1 hour steps (adjust to 60 for minutes)
              />
            </div>

            {/* End Time - native time input */}
            <div className={classes.timeFieldWrapper}>
              <label className={classes.timeLabel}>
                End Time <span className="req">*</span>
              </label>
              <input
                type="time"
                value={formValues?.end_time || ''}
                onChange={(e) => setFormValues({ ...formValues, end_time: e.target.value })}
                required
                className={classes.timeInput}
                step="3600"
              />
            </div>
          </div>

          <div className={classes.bottom}>
            <button onClick={handleClose} className={`${classes.flex} white-button`}>
              Cancel
            </button>

            <button onClick={handleConfirm} className={`${classes.flex} primary-button`}>
              Confirm
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default AddTimeModal